import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { NodeType } from '@reach/interfaces/nodes/node-type.enum';

import { ClientNode } from '../types/node';

@Pipe({
	name: 'nodeAsType',
	pure: true,
	standalone: true,
})
export class NodeAsTypePipe<TYPE extends NodeType> implements PipeTransform {
	transform(value: ClientNode, type: TYPE): ClientNode<TYPE> | null {
		if (value.nodeType === type) {
			return value as ClientNode<TYPE>;
		}
		return null;
	}
}

@Pipe({
	name: 'nodeAsFile',
	pure: true,
	standalone: true,
})
export class NodeAsFilePipe implements PipeTransform {
	transform(value: ClientNode): ClientNode<NodeType.FILE> | null {
		if (value.nodeType === NodeType.FILE) {
			return value as ClientNode<NodeType.FILE>;
		}
		return null;
	}
}

@Pipe({
	name: 'nodeAsWebsite',
	pure: true,
	standalone: true,
})
export class NodeAsWebsitePipe implements PipeTransform {
	transform(value: ClientNode): ClientNode<NodeType.WEBSITE> | null {
		if (value.nodeType === NodeType.WEBSITE) {
			return value as ClientNode<NodeType.WEBSITE>;
		}
		return null;
	}
}

const pipes = [NodeAsTypePipe, NodeAsFilePipe, NodeAsWebsitePipe];

@NgModule({
	imports: [...pipes],
	exports: [...pipes],
})
export class NodeAsTypeModule {}
